import translation from '@/translations/resources/cs/notification-service-extension'
import i18n from 'i18next'

const instance = i18n.createInstance({
    resources: { cs: { translation } },
})

export default instance
